import { Marker } from "react-mapbox-gl";
import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { setZoomFromMouseEvent } from "../../../reducers/map/thunkActions";
import { locationClickHandler } from "../../../reducers/ownApp/thunkActions";
import { processLocationEditAction } from "../../../reducers/matrixProfile/thunkActions";
import { routeInEditSelector } from "../../../reducers/matrixProfile/selectors";

const useStyles = makeStyles({
  tileMarker: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
  },
  tile: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    boxShadow: "1px 1px",
    borderRadius: "8px",
    backgroundColor: palette.white,
  },
  tileContent: {
    fontSize: "12px",
    fontWeight: "bold",
    padding: "1px 5px",
    border: "1px solid black",
    borderRadius: "8px",
  },
  descriptionMarker: {
    pointerEvents: "none",
  },
  description: {
    paddingTop: "12px",
    color: palette.grey,
    fontWeight: 400,
  },
});

export const LocationMarker = ({ location }) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const routeEdit = useSelector(routeInEditSelector);
  const { locationCode, name, longitude, latitude } = location;
  return (
    <>
      <Marker
        className={styles.tileMarker}
        coordinates={{
          lat: latitude,
          lng: longitude,
        }}
        anchor={"center"}
        onWheel={(e) => dispatch(setZoomFromMouseEvent(e))}
        onClick={() => {
          if (routeEdit) dispatch(processLocationEditAction({ locationCode }));
          else dispatch(locationClickHandler({ locationCode }));
        }}
      >
        <div className={styles.tile}>
          <div className={styles.tileContent}>{locationCode}</div>
        </div>
      </Marker>
      <Marker
        className={styles.descriptionMarker}
        coordinates={{
          lat: latitude,
          lng: longitude,
        }}
        anchor={"top"}
      >
        <div className={styles.description}>{name}</div>
      </Marker>
    </>
  );
};
